import { render, staticRenderFns } from "./gdpr-archived-tasks.vue?vue&type=template&id=4e982a3c"
import script from "./gdpr-archived-tasks.vue?vue&type=script&lang=js"
export * from "./gdpr-archived-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports